export const pdfStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

  body {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    padding: 60px 80px;
    line-height: 1.65;
    color: #334155;
    background-color: white;
    max-width: 850px;
    margin: 0 auto;
  }

  .header {
    border-bottom: 2px solid #f1f5f9;
    padding-bottom: 24px;
    margin-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }

  .brand {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .logo {
    font-size: 22px;
    font-weight: 700;
    color: #2563eb;
    letter-spacing: -0.02em;
    margin: 0;
  }

  .tagline {
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
  }

  .date {
    font-size: 13px;
    color: #94a3b8;
  }

  h1, h2, h3, h4 {
    color: #0f172a;
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    font-weight: 700;
    line-height: 1.3;
  }

  h1 { font-size: 2em; margin-top: 0; }
  h2 { font-size: 1.5em; border-bottom: 1px solid #f8fafc; padding-bottom: 8px; }
  h3 { font-size: 1.25em; }

  p { margin-bottom: 1.2em; }

  ul, ol {
    margin-bottom: 1.5em;
    padding-left: 1.5em;
  }

  li {
    margin-bottom: 0.6em;
  }

  blockquote {
    margin: 2em 0;
    padding: 1em 1.5em;
    border-left: 4px solid #e2e8f0;
    background: #f8fafc;
    color: #475569;
    font-style: italic;
  }

  code {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
    background: #f1f5f9;
    padding: 0.2em 0.4em;
    border-radius: 4px;
    font-size: 0.9em;
  }

  pre {
    background: #1e293b;
    color: #f8fafc;
    padding: 1.5em;
    border-radius: 8px;
    overflow-x: auto;
    margin-bottom: 1.5em;
  }

  pre code {
    background: transparent;
    padding: 0;
    color: inherit;
  }

  strong { color: #0f172a; font-weight: 600; }

  a { color: #2563eb; text-decoration: none; border-bottom: 1px solid rgba(37, 99, 235, 0.2); }

  .content { margin-top: 0; }

  .footer {
    margin-top: 80px;
    font-size: 11px;
    color: #94a3b8;
    border-top: 1px solid #f1f5f9;
    padding-top: 30px;
    text-align: center;
    line-height: 1.5;
  }

  .sources {
    margin-top: 60px;
    border-top: 2px solid #f1f5f9;
    padding-top: 24px;
  }

  .sources h2 {
    font-size: 1.2rem;
    color: #64748b;
    margin-top: 0;
    margin-bottom: 20px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border: none;
  }

  .source-item {
    margin-bottom: 15px;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .source-link {
    font-weight: 600;
    color: #2563eb;
    text-decoration: none;
    font-size: 14px;
  }

  .source-url {
    color: #94a3b8;
    font-size: 12px;
    word-break: break-all;
  }

  @media print {
    body { padding: 40px; }
    .header { margin-bottom: 30px; }
    pre { white-space: pre-wrap; word-wrap: break-word; }
  }
`;
